import { useTranslation } from 'react-i18next'

import { getApplicantMaskedFieldText } from '../../../../../RentalPortalApplicant'
import { TableTextCell, TableUserCell } from '../../../../../Table'
import { getIsApplicantProfileEmailMasked } from '../../RentalPortalApplicantProfileEmails.utils'

import { toApplicantProfileEmailsParticipantValue } from './ApplicantProfileEmailsParticipantCell.utils'

function ApplicantProfileEmailsParticipantCell({ item, ...restProps }) {
  const { t } = useTranslation()

  return getIsApplicantProfileEmailMasked(item) ? (
    <TableTextCell
      {...restProps}
      showTooltip={false}
      unread={!item.is_read}
      value={getApplicantMaskedFieldText({
        field: item.participant,
        maskedKey: 'RentalPortal.ApplicantProfileMaskedValueKey',
        t,
      })}
    />
  ) : (
    <TableUserCell
      {...restProps}
      unread={!item.is_read}
      value={toApplicantProfileEmailsParticipantValue(item.participant)}
    />
  )
}

export default ApplicantProfileEmailsParticipantCell
